<!-- Hardcoded ids  -->

<form [formGroup]="form" fxLayout="column" autocomplete="off"
  autocorrect="off" fxLayoutGap="25px" novalidate>
  <!--Image Logo-->
  <img id="id_login_landing_page_img_cfs_logo" class="logo" [src]="imgUrl" alt="E-Science Logo">

  <!--Statement Logo-->
  <!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

  <mat-label id="id_login_landing_page_lbl_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
    {{errorMessage}}
  </mat-label>

  <mat-form-field>
    <mat-select id="deconsolidator_dropdown_login_landing_page_dropdown" placeholder="Deconsolidator" formControlName="deconsolidator">
      <mat-option id="deconsolidator_dropdown_login_landing_page_dropdown_option" *ngFor="let data of deconsolidatorList" [value]="data">
        {{ data.description }}
      </mat-option>

      <mat-option id="deconsolidator_dropdown_login_landing_page_dropdown_option_no_data" *ngIf="deconsolidatorList.length == 0" disabled>No Data Available</mat-option>
    </mat-select>
    <mat-error id="deconsolidator_dropdown_login_landing_page_dropdown_error_required" *ngIf="form.controls['deconsolidator'].hasError('required')">
      Required Field
    </mat-error>
  </mat-form-field>

  <button id="id_login_landing_page_btn_proceed" color="primary" [disabled]="isSubmitting" mat-raised-button (click)="proceed(form.getRawValue())">
    <div fxLayout fxLayoutAlign="center center">
      <span style="padding-right: 2%">
        {{ (isSubmitting ? 'LOGGING_IN' : 'PROCEED') | translate }}
      </span>
      <mat-spinner [diameter]="20" color="accent" *ngIf="isSubmitting"></mat-spinner>
    </div>
  </button>
  <button  id="id_login_landing_page_btn_back" [disabled]="isSubmitting" mat-raised-button (click)="back()">
    <div fxLayout fxLayoutAlign="center center">
      <span style="padding-right: 2%">
        BACK
      </span>
    </div>
  </button>


</form>